import { render, staticRenderFns } from "./send-template.vue?vue&type=template&id=7fc0589a"
import script from "./send-template.vue?vue&type=script&lang=js"
export * from "./send-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports